/** Reasons why standard-position-ms discards an incoming position. */
export enum PositionDiscardReason {
    // GPS checks (keys match ValidateHydratedPositionUsecase validation results)
    SATELLITE_COUNT = 'satelliteCount',
    ORIGIN_POSITION = 'originPosition',
    ALTITUDE = 'altitude',
    HDOP = 'hdop',
    SPEED_THRESHOLD = 'speedThreshold',
    SPEED_REASONABLE = 'speedReasonable',
    STATIONARY_JUMP = 'stationaryJump', // mobile only

    MISSING_COORDINATES = 'missingCoordinates',
    FUTURE_DATE = 'futureDate', // device clock reports a date too far in the future
    STALE_OR_DUPLICATE = 'staleOrDuplicate', // older than or almost identical to the last report
}
